export const ADD_ITEM_TO_CART_REQUEST = 'ADD_ITEM_TO_CART_REQUEST';
export const ADD_ITEM_TO_CART_SUCCESS = 'ADD_ITEM_TO_CART_SUCCESS';
export const ADD_ITEM_TO_CART_FAILURE = 'ADD_ITEM_TO_CART_FAILURE';

export const GET_CART_REQUEST = 'GET_CART_REQUEST';
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
export const GET_CART_FAILURE = 'GET_CART_FAILURE';

export const REMOVE_CART_ITEM_REQUEST = 'REMOVE_CART_ITEM_REQUEST';
export const REMOVE_CART_ITEM_SUCCESS = 'REMOVE_CART_ITEM_SUCCESS';
export const REMOVE_CART_ITEM_FAILURE = 'REMOVE_CART_ITEM_FAILURE';

export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export const UPDATE_CART_ITEM_SUCCESS = 'UPDATE_CART_ITEM_SUCCESS';
export const UPDATE_CART_ITEM_FAILURE = 'UPDATE_CART_ITEM_FAILURE';

// Guest Cart Action Types (local-only, sessionStorage)
export const LOAD_GUEST_CART = 'LOAD_GUEST_CART';
export const ADD_GUEST_CART_ITEM = 'ADD_GUEST_CART_ITEM';
export const REMOVE_GUEST_CART_ITEM = 'REMOVE_GUEST_CART_ITEM';
export const UPDATE_GUEST_CART_ITEM = 'UPDATE_GUEST_CART_ITEM';
export const CLEAR_GUEST_CART = 'CLEAR_GUEST_CART';
export const BULK_LIMIT_EXCEEDED = 'BULK_LIMIT_EXCEEDED';

// Cart Merge Action Types (after authentication)
export const MERGE_CART_REQUEST = 'MERGE_CART_REQUEST';
export const MERGE_CART_SUCCESS = 'MERGE_CART_SUCCESS';
export const MERGE_CART_FAILURE = 'MERGE_CART_FAILURE';

// Clear User Cart Action Types (after order placed)
export const CLEAR_USER_CART_REQUEST = 'CLEAR_USER_CART_REQUEST';
export const CLEAR_USER_CART_SUCCESS = 'CLEAR_USER_CART_SUCCESS';
export const CLEAR_USER_CART_FAILURE = 'CLEAR_USER_CART_FAILURE';